import React from "react";
import { Button, Box } from "@mui/material";
import Webcam from "react-webcam";
import { isMobile } from "react-device-detect";

const ocrVideoConstraints = {
  width: { ideal: 1920 },
  height: { ideal: isMobile ? 1440 : 1152 },
  aspectRatio: { ideal: isMobile ? 1.333333333 : 1.777777778 },
  facingMode: { ideal: isMobile ? "environment" : "user" },
};

export default function CardCaptureCamera(props) {
  const [mediaStream, setMediaStream] = React.useState(false);
  const cameraRef = React.useRef(null);

  const handleUserMediaError = () => {
    props.handleClose();
    props.handleAlert("Không kết nối được đến thiết bị chụp ảnh");
  };

  const handleCapturePhoto = () => {
    const width = cameraRef.current.video.videoWidth;
    const height = cameraRef.current.video.videoHeight;
    const cropWidth = (width * (isMobile ? 95 : 75)) / 100;
    const cropHeight = cropWidth / 1.586;

    const data = cameraRef.current.getScreenshot({
      width,
      height,
    });

    props.handleClose();
    props.onTakingImage(data, width, height, cropWidth, cropHeight);
  };

  const handleGetUserMedia = () => {
    setMediaStream(true);
  };

  let mask;
  if (mediaStream) {
    mask = (
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderColor: "#7FFF00",
          borderStyle: "solid",
          width: isMobile ? "90%" : "70%",
          height: "0",
          paddingBottom: isMobile ? "56.747%" : "44.136%",
          boxShadow: "0 0 0 600px rgba(0, 0, 0, 0.6)",
        }}
      />
    );
  } else {
    mask = (
      <Box
        sx={{
          width: "100%",
          paddingBottom: isMobile ? "133.333333333%" : "56.25%",
          height: 0,
          backgroundColor: "black",
        }}
      />
    );
  }

  return (
    <>
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <Webcam
          videoConstraints={ocrVideoConstraints}
          screenshotFormat="image/jpeg"
          ref={cameraRef}
          onUserMediaError={handleUserMediaError}
          style={
            mediaStream
              ? {
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  backgroundColor: "black",
                }
              : {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "1%",
                }
          }
          onPlay={handleGetUserMedia}
        />
        {mask}
      </Box>

      <Box sx={{ width: "100%", marginTop: "0.5rem", display: "flex" }}>
        <Button
          onClick={handleCapturePhoto}
          variant="contained"
          sx={{ marginLeft: "auto", marginRight: "auto" }}
        >
          Chụp ảnh
        </Button>
      </Box>
    </>
  );
}
